import React from "react";
import ReactDOM from 'react-dom';
import "bootstrap-icons/font/bootstrap-icons.css";

const footerText="MCS Tutor © 2022";


export function endpoint(path) {
    var url = 'http://127.0.0.1:8000/' + path;
    return url;
}

export function Title(props) {
  const text = props.text, size = props.size;

  var element = <><div style={{textAlign:"center"}}>
  {size===1?<h5 className="title">{text}</h5>:
  size===2?<h3 className="title">{text}</h3>:
  size===3?<h1 className="title">{text}</h1>:
  <h1 className="title">{text}</h1>}</div><br/></>;

  return element;
}

export function Footer(props) {
  const text = props.text!==undefined?props.text:footerText;
  var footer = <footer><p><b>Email:</b> mcstutor.brampton@gmail.com
   <b style={{marginLeft:"25px"}}>Cell:</b> 647-913-9900<br/>{text}</p></footer>;
  return footer;
}

export function Input(props) {
  const type = props.type===undefined?"text":props.type;
  const field = <input className="form-control" type={type} placeholder={props.placeholder}/>;
  return <div style={props.style}>{field}</div>;
}

export function Button(props) {
  const type = props.type===undefined?"text":props.type;
  const className=props.className===undefined?"btn btn-primary":props.className;
  const btn = <button className={className} type={type}
   placeholder={props.placeholder}>{props.text}</button>;
  return <div style={props.style}>{btn}</div>;
}
